import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import Banner from '../models/Banner';

export function getBanners(params) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.BANNER_LIST,
        params: params,
        parser: bannersDataParser,
    }).get();
}

export function getBannerDetail(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.BANNER_DETAIL,
        endpointParams: { id },
        parser: data => new Banner(data.data),
    }).get();
}

export function createBanner(banner) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.BANNER_CREATE,
    }).post(banner.export());
}

export function updateBanner(banner) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.BANNER_UPDATE,
    }).put(banner.export());
}

export function deleteBanner(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.BANNER_DELETE,
        endpointParams: { id },
    }).delete();
}

export function createBannerTranslate(banner) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.BANNER_TRANSLATE_CREATE,
    }).post(banner.export(true).translate());
}

export function updateBannerTranslate(banner) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.BANNER_TRANSLATE_UPDATE,
    }).put(banner.export(true).translate());
}

export function deleteBannerTranslate(id) {
    return new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.BANNER_TRANSLATE_DELETE,
        endpointParams: { id },
    }).delete();
}


function bannersDataParser(data = {}) {
    return {
        ...data.data,
        result: (data.data.result || []).map(item => new Banner(item))
    }
}